<template>
  <draggable
    :group="{ name: 'undistributed', pull: true, put: pullCheck }"
    :list="targetDriver.schedules"
    :class="`${typeable}`"
    :name="`dragArea_${targetDriver.id}`"
    :move="onMove"
    :style="targetDriver.schedules.length > 0 ? `display:inline-flex;` : ''"
    :typeable="typeable"
    class="dragArea"
    tag="ul"
    ghost-class="ghost"
    @add="unassignedOrderAddEvent"
    @end="onEndEvent"
  >
    <li
      v-for="schedule in targetDriver.schedules"
      :key="schedule.id"
      :class="schedule.schedule_type"
      class="rounded-card"
    >
      <v-card
        class="fill-height rounded-card"
        flat
        :class="cardStyle(schedule)"
      >
        <v-card-text
          style="height: 100%;padding: 1px 1px 1px 4px"
        >
          <div
            v-if="schedule.schedule_type !== 'destination'"
            style="position: absolute;right: 10px;top: 2px;"
          >
            <!-- カードに表示するメニュー -->
            <card-menus
              :schedule="schedule"
              :is-previous="isPrevious"
              @collectionCardMenuCallback="collectionCardMenuCallback"
              @instructionCardMenuCallback="instructionCardMenuCallback"
            />
            <!-- /カードに表示するメニュー -->
          </div>
          <v-badge
            v-if="schedule.schedule_type === 'collection'"
            :content="schedule.schedule_type | task_type_label"
            color="info"
            dark
            inline
            class="customBadge"
          />
          <v-badge
            v-if="schedule.schedule_type === 'destination'"
            inline
            color="white"
            class="customBadge"
          >
            <template v-slot:badge>
              <span style="color:#1EABD1;" class="font-weight-bold">{{ schedule.schedule_type | task_type_label }}</span>
            </template>
          </v-badge>
          <v-badge
            v-if="schedule.schedule_type === 'instruction'"
            color="#555555"
            dark
            inline
          >
            <template v-slot:badge>
              <v-icon>mdi-pencil</v-icon>
            </template>
          </v-badge>
          <small
            v-if="schedule.schedule_type === 'collection' && ( schedule.preferred_start_time || schedule.preferred_end_time )"
            class="red--text"
          >
            {{ schedule.preferred_start_time }}-{{ schedule.preferred_end_time }}
          </small>
          <v-icon
            v-if="schedule.urgent && !schedule.collected_date"
            color="red"
            x-small
          >
            mdi-circle
          </v-icon>

          <small
            v-if="schedule.schedule_type === 'destination' && schedule.schedules.length > 0"
            class="white--text font-weight-bold"
          >
            {{ schedule.schedules.length + 1 }}件
          </small>
          <!-- /回収先の場合 -->
          <h5
            v-if="schedule.schedule_type === 'collection'"
            class="pl-1"
            :title="`受注番号: ${schedule.order_no}\n${schedule.supplier_name || ''}\n${schedule.supplier_location_name || ''}: ${schedule.supplier_location_address || ''}\n${schedule.item_name}`"
          >
            {{ schedule.supplier_location_name }}
          </h5>

          <!-- 運搬先 -->
          <h5
            v-else-if="schedule.schedule_type === 'destination'"
            class="pl-1"
            :title="`${schedule.trader_name}\n${schedule.trader_location_name}: ${schedule.trader_location_address}`"
          >
            {{ schedule.trader_location_name }}
          </h5>
          <h5
            v-else-if="schedule.schedule_type === 'instruction'"
            class="pl-1"
            :title="schedule.title"
          >
            {{ schedule.title }}
          </h5>
          <h5
            v-if="schedule.schedule_type === 'collection'"
            :title="schedule.vehicle_number || ''"
            style="display: block;"
          >
            <span class="pl-1">
              {{ schedule.vehicle_name || '' }}&nbsp;
            </span>
          </h5>
        </v-card-text>
      </v-card>
      <!--
        運搬先は結合処理の関係上ulがz-indexで最上位になるため、ul自体にtitleをつけないとマウス当ててもタイトルが出ない
      -->
      <nested-task
        v-if="schedule.schedule_type === 'destination'"
        :target-driver-id="targetDriver.id"
        :parent-schedule="schedule"
        :schedules="schedule.schedules"
        :target-date="targetDate"
        :title="`${ schedule.trader_name || '' }\n${ schedule.trader_location_name || '' }\n${ schedule.trader_location_address || '' }`"
        @reloadDriverSchedule="reloadDriverSchedule"
      />
    </li>
    <confirm ref="confirm" />
  </draggable>
</template>

<script>
import Draggable from 'vuedraggable'
import Confirm from '../../../../components/Confirm'
import NestedTask from './_NestedTask'
import CardMenus from '../components/_CardMenus'
import { mapActions } from 'vuex'
export default {
  name: 'UserTask',
  components: {
    Confirm,
    Draggable,
    CardMenus,
    NestedTask,
  },
  mixins: [],
  props: {
    /**
     * ドライバー
     */
    targetDriver: {
      type: Object,
      default: () => {}
    },
    /**
     * 種別
     * first: 1階層
     * nested: 2階層(マージされた運搬)
     */
    typeable: {
      type: String,
      default: () => null
    },
    targetDate: {
      type: String,
      default: () => null,
    },
    isPrevious: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      canMove: false,
    }
  },
  computed: {},
  created() {
  },
  methods: {
    ...mapActions('DriverAllocationDriverSchedule', {
      rearrangeDriverSchedule: 'create',
    }),
    /**
     * 回収カードのメニュークリックコールバック
     * @param menu { String } メニュー種別
     * @param item { Object } 対象
     */
    collectionCardMenuCallback (menu, item) {
      switch (menu) {
        case 'instruction_edit':
          this.driverInstructionEditButtonClickEvent(item)
          break
        case 'register_vehicle':
          this.callVehicleDialogButtonClickEvent(item)
          break
        case 'release_dispatch':
          // 配車を解除
          this.releaseDispatchButtonClickEvent(item)
          break
        case 'cancel_dispatch':
          this.cancelDispatchButtonClickEvent(item)
          break
      }
    },
    /**
     * その他指示メモカードのメニュークリックコールバック
     * @param menu
     * @param item
     */
    instructionCardMenuCallback (menu, item) {
      switch (menu) {
        case 'register_memo':
          this.callInstructionDialogButtonClickEvent(item)
          break
        case 'remove_memo':
          this.removeMemoButtonClickEvent(item)
          break
      }
    },
    reloadDriverSchedule () {
      this.$emit('reloadDriverSchedule', this.targetDriver.id)
    },
    /**
     * ドライバー指示メモ 編集メニュー クリックイベント
     */
    driverInstructionEditButtonClickEvent (task) {
      this.$emit('openDriverInstructionDialog', this.targetDriver.id, task)
    },
    /**
     * 車両を指定するメニュー クリックイベント
     * @param task { Object }
     */
    callVehicleDialogButtonClickEvent (task) {
      this.$emit('callVehicleDialog', this.targetDriver.id, task)
    },
    /**
     * その他配車指示メモ 編集メニュー クリックイベント
     * @param task { Object }
     */
    callInstructionDialogButtonClickEvent (task) {
      this.$emit('callInstructionEditDialog', this.targetDriver.id, task)
    },
    /**
     * その他配車指示メモ 削除メニュー クリックイベント<br/>
     *
     * @param schedule { Object }
     */
    removeMemoButtonClickEvent (schedule) {
      this.$emit('removeInstructionCallBack', this.targetDriver.id, schedule.id)
    },
    /**
     * 配車を解除するメニュー クリックイベント
     */
    releaseDispatchButtonClickEvent (schedule) {
      let modalOption = { title: '配車を解除', message: '配車を解除します。よろしいですか？', options: { titleColor: 'red', cancelTitle: 'いいえ', successTitle: 'はい' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$emit('releaseDispatchCallback', this.targetDriver.id, schedule.order_id)
        }
      })
    },
    cancelDispatchButtonClickEvent (schedule) {
      const options = { titleColor: 'red', width: 450, cancelTitle: 'いいえ', successTitle: 'はい', cancelButtonColor: 'primary', successButtonColor: 'grey' }
      let modalOption = { title: 'キャンセル', message: ' JWNETに連携されたデータが含まれる場合は削除されますが、よろしいですか？', options: options }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$emit('cancelOrderCallback', this.targetDriver.id, schedule.order_id)
        }
      })
    },
    /**
     * タスクが持つ種別により背景色を決定させる.
     * @param schedule
     * @return {string}
     */
    cardStyle (schedule) {
      let style = []
      if (schedule.schedule_type === 'destination') {
        style.push('info')
      }
      if (schedule.confirmed) {
        style.push('confirmed')
      }
      return style.join(' ')
    },
    pullCheck (to, from) {
      if (this.isPrevious) {
        return false
      }
      let fromName = from.options.name
      let toName   = to.options.name
      let toType = to.options.typeable


      // 受注一覧からのドラッグの場合は運搬先へのドロップを許可しない
      if (fromName.match(/main_task/) || fromName  === 'urgent_task' || fromName  === 'unspecified_task') {
        return (toType !== 'nested')
      }

      if (fromName !== toName) {
        return false
      }
    },
    /**
     * 右スライド D&Dによる受注の登録
     */
    unassignedOrderAddEvent (a, b) {
      this.addTaskEvent()
    },
    /**
     * ドラッグ中のイベント
     * 運搬が先頭に来ることを許可しない処理
     * collection: 回収
     * destination: 運搬
     * instruction: その他配車指示
     * @param evt
     * @return {boolean}
     */
    onMove (evt) {

      this.canMove = false
      const futureIndex = evt.draggedContext.futureIndex
      if (this.isPrevious) {
        return false
      }

      // 移動元
      let draggedContext = evt.draggedContext
      // 移動先
      let relatedContext = evt.relatedContext

      if (draggedContext.element) {

        let draggedElement  = draggedContext.element

        // 確定済のカードは操作不可とする.
        if (draggedElement.confirmed) {
          return false
        }

        /**
         * 回収
         * ・対となる運搬より後ろへの移動は不可とする.
         * ・結合された運搬より後ろへの移動は不可とする
         */
        if (draggedElement.schedule_type === 'collection') {
          // 後ろへの移動
          if (evt.willInsertAfter) {
            // 要素が取得できた場合
            if (relatedContext.element) {
              // 展開されている一覧の中から対になる運搬の位置を保持
              let destinationIndex = relatedContext.list.findIndex((v) => v.order_id === draggedElement.order_id && v.schedule_type === 'destination' )
              // 移動先となる位置より運搬の位置が前であれば移動不可
              if (draggedContext.futureIndex >= destinationIndex) {
                return false
              }
            }

            // 回収が運搬先に統合されないように制御
            if (relatedContext.component.$attrs.typeable === 'nested') {
              return false
            }
          }
          this.canMove = true
          /**
           * 運搬
           * ・運搬は対となる回収より前への移動は不可とする.
           * ・結合された運搬も同様に結合した運搬と対になる回収より前への移動は不可とする.
           * ・結合は運搬事業者ID, 事業場コードが一致する場合のみ可能とする.
           */
        } else if (draggedElement.schedule_type === 'destination') {

          // 対となる回収より前に移動させない制御 ===>
          let draggableMembers = [draggedElement]
          for (const schedule of draggedElement.schedules) {
            draggableMembers.push(schedule)
          }
          let canMove  = true
          for (let i = 0; i < draggableMembers.length; i++) {
            let member = draggableMembers[i]
            // 同オーダーIDを持つ回収の位置を取得
            let collectionIndex = relatedContext.list.findIndex((v) => v.order_id === member.order_id && v.schedule_type === 'collection' )
            // 運搬の移動先Indexが回収より前の場合は移動不可
            if (draggedContext.futureIndex <= collectionIndex) {
              canMove = false
              break
            }
          }
          if (!canMove) {
            return false
          }
          // <===

          /**
           * 掴んだカードの移動先Index(futureIndex)が取れなくなる場合がある...
           * 取れない場合はマージ先のindexと対となる回収カードのindexを比較し、回収カードより前にある場合はエラーとする.
           *
           * 移動先Index(futureIndex)が取得できた場合は
           */
          if (futureIndex <= 0) {
            let collectionIndex = relatedContext.component.$parent.$parent.list.findIndex((v) => v.order_id === draggedElement.order_id && v.schedule_type === 'collection' )
            if (relatedContext.component.$parent && relatedContext.component.$parent.parentSchedule) {
              const parentSchedule = relatedContext.component.$parent.parentSchedule
              let mergeIndex = relatedContext.component.$parent.$parent.list.findIndex((v) => v.id === parentSchedule.id )
              if (parentSchedule.trader_id !== draggedElement.trader_id || parentSchedule.trader_location_code !== draggedElement.trader_location_code) {
                return false
              }
              if (collectionIndex > mergeIndex) {
                return false
              }
            }
          }

          /**
           * その他配車指示
           * ・特になし
           */
        } else if (draggedContext.element.schedule_type === 'instruction') {
          if (relatedContext.element === undefined) {
            return false
          }
        }

      }
      this.canMove = true
      return true
    },
    /**
     *
     * @param dataTransfer
     * @param dragEl
     * @return {boolean}
     */
    onEndEvent (dataTransfer, dragEl) {
      if (!this.canMove) {
        return false
      }
      if (dataTransfer.oldIndex !== dataTransfer.newIndex) {
        this.addTaskEvent()
      }
      return false
    },
    /**
     * 受注のD&D, 並び替えの登録
     */
    addTaskEvent () {
      let schedules = []
      // ドライバーのスケジュールを走査
      for (const result of this.targetDriver.schedules) {
        if (result.order_id) {
          let integratedSchedules = []
          if (result.schedules) {
            for( const integrated_schedule of result.schedules) {
              integratedSchedules.push({ original_id: integrated_schedule.original_id, order_id: integrated_schedule.order_id, schedule_type: integrated_schedule.schedule_type })
            }
          }
          schedules.push({ original_id: result.original_id, order_id: result.order_id, schedule_type: result.schedule_type, schedules: integratedSchedules })
        } else {
          // その他指示メモ
          schedules.push({ original_id: result.original_id, schedule_type: result.schedule_type })
        }
      }
      let params = {
        target_date: this.targetDate,
        schedules: schedules
      }
      this.rearrangeDriverSchedule({ driver_id: this.targetDriver.id, params: params }).then(() => {
        this.$emit('reloadAllocations')
        this.reloadDriverSchedule()
      })
    }
  },
}
</script>

<style scoped lang="scss">
.no-shadow {
  box-shadow: none !important;
}
.customBadge {
  & .v-badge__badge {
    font-size: 10px;
  }
}

.confirmed {
  opacity: 0.4;
}

.ghost {
  opacity: 0.4;
}
ul.dragArea {
  list-style-type: none;
  height: 100%;
  &.first {
    padding-right: 100px;
  }
  &.nested {
    opacity: 0;
    top: 0;
    position: absolute;
    height: 100%;
    z-index: 3;
    width: 100%;
    & li {
      display: none;
    }
  }
  & li {
    position: relative;
    float: left;
    //height: 50px;
    height: 73px;
    width: 150px;
    border: 1px solid #ddd;
    margin: 0 3px;

    & h5 {
      white-space:nowrap;
      width: 85%;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    &.destination {
      width: 80px;
      & h5 {
        color: white !important;
        & span {
          color: white !important;
        }
      }
    }
    &.instruction {
      width: 90px;
      & .v-card {
        background-color: #FDEFC1 !important;
      }
    }
  }
}

</style>
